import { httpClient } from '@/network/clientController'

/** Get list of fast links for login accelarators
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_internetdashboardcard
*/
export const getDashboardCards = ({ params }) => {
	return httpClient({
		method: 'GET',
		url: 'dashboardcard',
		isCancellable: true,
		params: params
	})
}
